<template>
  <div>
    <main role="main">
      <div class="page-content">
        <div class="container py-md-5 py-4">
          <div class="row justify-content-center">
            <div class="col-lg-10">
              <div class="row align-items-center mb-4">
                <div class="col-md-4">
                  <h2 class="page-title mb-md-0 mb-3">Settings</h2>
                </div>
                <div
                  class="col-md-8 form-style d-flex justify-content-end"
                ></div>
              </div>
              <div class="row align-items-center mb-2">
                <div class="col-lg-12">
                  <ul
                    class="nav nav-pills mb-3 tab-style-1"
                    id="login-tab"
                    role="tablist"
                  >
                    <li class="nav-item" role="presentation">
                      <a
                        class="nav-link"
                        :class="currentTab == 'CONTACT' ? 'activ' : ''"
                        data-bs-toggle="pill"
                        href="#tab_1"
                        role="tab"
                        aria-controls="tab_1"
                        aria-selected="true"
                        v-on:click="changeTab('CONTACT')"
                        >Contact Privacy</a
                      >
                    </li>
                    <li class="nav-item" role="presentation">
                      <a
                        class="nav-link"
                        data-bs-toggle="pill"
                        :class="currentTab == 'CHANGE_PASSWORD' ? 'activ' : ''"
                        href="#tab_2"
                        role="tab"
                        v-on:click="changeTab('CHANGE_PASSWORD')"
                        aria-controls="tab_2"
                        aria-selected="false"
                        >Change Password</a
                      >
                    </li>
                    <li class="nav-item" role="presentation">
                      <a
                        class="nav-link"
                        :class="currentTab == 'DELETE_PROFILE' ? 'activ' : ''"
                        data-bs-toggle="pill"
                        href="#tab_3"
                        role="tab"
                        aria-controls="tab_3"
                        aria-selected="false"
                        v-on:click="changeTab('DELETE_PROFILE')"
                        >Delete Profile</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="tab-content form-style">
                <div
                  class="tab-pane fade show active"
                  id="tab_1"
                  role="tabpanel"
                >
                  <div
                    v-for="(data, index) in phoneNumberList"
                    :key="index"
                    class="row justify-content-center mb-3 align-items-center"
                  >
                    <div class="col-md-2 col-4">
                      <label class="font-18 font-medium">{{
                        data.type.replaceAll("_", " ")
                      }}</label>
                    </div>
                    <div class="col-md-3 col-4">
                      <label class="font-18">{{ data.phone }}</label>
                    </div>
                    <div class="col-md-4 col-4 row">
                      <div class="col-md-3 mt-1"><span>UNHIDE</span></div>

                      <div class="col-md-2 form-check form-switch">
                        <input
                          v-on:change="updatePhoneStatus(data)"
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          true-value="Y"
                          false-value="N"
                          v-model="data.is_hidden"
                          :id="'switch_' + index"
                        />
                        <label class="form-check-label" for="switch_1"> </label>
                      </div>

                      <div class="col-md-1 mt-1"><span>HIDE</span></div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane fade" id="tab_2" role="tabpanel">
                  <Form ref="changePassword" @submit="change()">
                    <div class="row justify-content-center">
                      <div class="col-md-6">
                        <div class="form-group align-item-center col-12 mb-3">
                          <label>Current Password</label>
                          <div class="input-group mb-3">
                            <Field
                              :type="oldPasswordFieldType"
                              id="oldpassword"
                              name="oldpassword"
                              class="form-control password"
                              placeholder="Current Password"
                              v-model="reset.old_password"
                              v-on:keydown.space="$event.preventDefault()"
                              rules="required:Current Password|minLength:6|password"
                              :validateOnInput="true"
                            /><span
                              class="input-group-text"
                              id="basic-addon2"
                              style="border-radius: 0px 8px 8px 0px"
                              ><a
                                v-on:click="switchVisibilityOld"
                                class="psw-icon"
                                ><img :src="imageOld" width="20" /></a
                            ></span>
                          </div>
                          <ErrorMessage
                            name="oldpassword"
                            class="validation-msg"
                          />
                        </div>
                        <div class="form-group align-item-center col-12 mb-3">
                          <label>New Password</label>
                          <div class="input-group mb-3">
                            <Field
                              :type="newPasswordFieldType"
                              id="password"
                              name="password"
                              class="form-control password"
                              placeholder="New Password"
                              v-model="reset.password"
                              v-on:keydown.space="$event.preventDefault()"
                              rules="required:New Password|minLength:6|password"
                              :validateOnInput="true"
                            /><span
                              class="input-group-text"
                              id="basic-addon2"
                              style="border-radius: 0px 8px 8px 0px"
                              ><a
                                v-on:click="switchVisibilityNew"
                                class="psw-icon"
                                ><img :src="imageNew" width="20" /></a
                            ></span>
                          </div>
                          <ErrorMessage
                            name="password"
                            class="validation-msg"
                          />
                        </div>
                        <div class="form-group align-item-center col-12 mb-3">
                          <label>Confirm Password</label>
                          <div class="input-group mb-3">
                            <Field
                              :type="PasswordFieldType"
                              id="confirm_password"
                              name="confirm password"
                              class="form-control password"
                              placeholder="Confirm Password"
                              v-model="reset.confirm_password"
                              v-on:keydown.space="$event.preventDefault()"
                              rules="required:Confirm Password|confirmed:@password"
                              :validateOnInput="true"
                            /><span
                              class="input-group-text"
                              id="basic-addon2"
                              style="border-radius: 0px 8px 8px 0px"
                              ><a v-on:click="switchVisibility" class="psw-icon"
                                ><img :src="image" width="20" /></a
                            ></span>
                          </div>
                          <ErrorMessage
                            name="confirm password"
                            class="validation-msg"
                          />
                        </div>
                        <div class="text-center mt-4">
                          <button
                            id="save-button"
                            class="btn btn-brand-1 px-5 me-3"
                          >
                            Save
                          </button>
                          <button
                            type="button"
                            class="btn btn-outline-brand-1 px-5"
                            v-on:click="$router.push('/dashboard')"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
                <div class="tab-pane fade" id="tab_3" role="tabpanel">
                  <div>
                    <p>
                      Please let us know the reason why you want to delete your
                      account
                    </p>
                    <div
                      class="form-check mb-3"
                      v-on:click="show('THROUGH_NIMBALKAR')"
                    >
                      <input
                        class="form-check-input"
                        type="radio"
                        name="DeleteReasonType"
                        id="DeleteReason_1"
                        value="THROUGH_NIMBALKAR"
                        v-model="detail.type"
                      />
                      <label class="form-check-label" for="DeleteReason_1">
                        Engaged/Married Through Nimbalkar Vadhu Var Suchak
                      </label>
                    </div>
                    <div
                      class="form-check mb-3"
                      v-on:click="show('NOT_THROUGH_NIMBALKAR')"
                    >
                      <input
                        class="form-check-input"
                        type="radio"
                        name="DeleteReasonType"
                        id="DeleteReason_2"
                        value="NOT_THROUGH_NIMBALKAR"
                        v-model="detail.type"
                      />
                      <label class="form-check-label" for="DeleteReason_2">
                        Engaged/Married Not Through Nimbalkar Vadhu Var Suchak
                      </label>
                    </div>
                    <div
                      class="form-check mb-3"
                      v-on:click="show('OTHER_REASON')"
                    >
                      <input
                        class="form-check-input"
                        type="radio"
                        name="DeleteReasonType"
                        id="DeleteReason_3"
                        value="OTHER_REASON"
                        v-model="detail.type"
                      />
                      <label class="form-check-label" for="DeleteReason_3">
                        Other Reason
                      </label>
                    </div>
                  </div>

                  <!-- onccheck 1 Radion Btn  -->
                  <div
                    v-if="type == 'THROUGH_NIMBALKAR'"
                    class="border rounded pt-3"
                  >
                    <h4 class="text-center font-medium mb-4">
                      Post Your Story
                    </h4>
                    <Form ref="saveSuccessStory" @submit="saveSuccessStory()">
                      <div class="row justify-content-center">
                        <div class="col-md-8">
                          <div class="row justify-content-center">
                            <div
                              class="col-lg-12 col-sm-12 form-group"
                              v-if="!uuid"
                            >
                              <label>Search Partner</label>

                              <div class="has-search">
                                <i
                                  class="fa fa-search"
                                  style="position: absolute; margin: 10px"
                                  aria-hidden="true"
                                ></i>
                                <Field
                                  type="text"
                                  placeholder="Search First Name / Last Name / Registration No."
                                  name="number"
                                  v-model="search_data"
                                  rules="required: Partner"
                                  :validateOnInput="true"
                                  v-slot="{ field }"
                                >
                                  <Multiselect
                                    ref="bride"
                                    mode="single"
                                    trackBy="name"
                                    label="name"
                                    valueProp="name"
                                    placeholder="Search First Name / Last Name / Registration No."
                                    searchable="true"
                                    v-model="search_data"
                                    object="true"
                                    :options="list"
                                    :disabled="uuid"
                                    @select="setDetail(search_data)"
                                    @search-change="
                                      searchByRefferenceId($event)
                                    "
                                    v-bind="field"
                                  >
                                    <template v-slot:option="{ option }">
                                      {{ option.name }}
                                    </template>
                                  </Multiselect>
                                </Field>
                                <ErrorMessage
                                  name="number"
                                  class="text-danger"
                                />
                              </div>
                            </div>

                            <div class="col-lg-12 col-sm-12">
                              <div class="form-group">
                                <label>Registration ID</label>

                                <Field
                                  type="text"
                                  name="registration_no"
                                  class="form-control"
                                  placeholder="Registration No."
                                  v-model="detail.registration_no"
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Partner First Name</label>

                                <Field
                                  type="text"
                                  name="name"
                                  class="form-control"
                                  placeholder="First Name"
                                  rules="required:first name"
                                  :validateOnInput="true"
                                  v-model="detail.first_name"
                                  disabled
                                />
                                <ErrorMessage name="name" class="text-danger" />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>Partner Last Name</label>
                                <Field
                                  type="text"
                                  name="last_name"
                                  class="form-control"
                                  placeholder="Last Name"
                                  v-model="detail.last_name"
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group">
                                <label for="">Couple Photo</label>
                                <div class="custom-select-img">
                                  <div class="file-upload">
                                    <div class="image-upload-wrap p-3 mb-4">
                                      <coverImagePicker
                                        :src="detail.image"
                                        :modelValue="detail.image"
                                        ref="ImagePicker"
                                      />
                                      <!-- <img
                                        :src="
                                          detail.image && detail.image != null
                                            ? detail.image
                                            : '/images/placeholder.png'
                                        "
                                        id="preview"
                                        class="img-fluid"
                                      />
                                      <input
                                        type="file"
                                        name="img[]"
                                        class="file"
                                        id="pickFile"
                                        @change="selectedFile($event)"
                                        accept="image/*"
                                        style="display: none"
                                      />
                                      <label for="pickFile">
                                        <div
                                          class="drag-text text-center"
                                          v-if="!detail.image"
                                        >
                                          <i
                                            class="fa fa-cloud-upload"
                                            aria-hidden="true"
                                          ></i>
                                          Upload Photo
                                        </div>
                                      </label> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="col-md-12">
                              <div class="form-group">
                                <label>Partner Family Location(city)</label>
                                <Field
                                  type="text"
                                  class="form-control"
                                  placeholder="Partner Family Location(city)"
                                  name="city"
                                  rules="required:city"
                                  :validateOnInput="true"
                                  v-model="detail.city"
                                  disabled
                                />
                                <ErrorMessage name="city" class="text-danger" />
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group">
                                <label
                                  >Comment/Feedback/Suggestion (If any)</label
                                >

                                <Field
                                  as="textarea"
                                  name="comment"
                                  class="form-control h-auto"
                                  id=""
                                  cols="30"
                                  rows="4"
                                  v-model="detail.comment"
                                ></Field>
                              </div>
                            </div>
                            <div class="col-12 text-center mt-4">
                              <button
                                id="confirm-delete-button"
                                class="btn btn-brand-1 px-5"
                              >
                                Confirm Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                    <!-- </Form> -->
                    <p class="text-center mt-4">
                      <span class="font-medium">Note:</span> Your Profile will
                      be deleted & success story will be posted after Partner's
                      Confirmation
                    </p>
                  </div>

                  <!-- onccheck 2 Radion Btn  -->
                  <div
                    v-if="type == 'NOT_THROUGH_NIMBALKAR'"
                    class="border rounded pt-3"
                  >
                    <div class="row justify-content-center">
                      <div class="col-md-8">
                        <div class="row justify-content-center">
                          <Form
                            ref="NotThroughNimbakar"
                            @submit="saveSuccessStory()"
                          >
                            <div class="col-md-12">
                              <div class="form-group">
                                <label
                                  >Comment/Feedback/Suggestion (If any)</label
                                >

                                <Field
                                  as="textarea"
                                  class="form-control h-auto"
                                  id=""
                                  cols="30"
                                  rows="4"
                                  name="comment"
                                  rules="required:comment"
                                  :validateOnInput="true"
                                  v-model="detail.comment"
                                ></Field>
                                <ErrorMessage
                                  name="comment"
                                  class="text-danger"
                                />
                              </div>
                            </div>
                            <div class="col-12 text-center mt-4">
                              <button
                                id="confirm-delete-button"
                                class="btn btn-brand-1 px-5"
                              >
                                Confirm Delete
                              </button>
                            </div>
                          </Form>
                        </div>
                        <p class="text-center mt-4">
                          <span class="font-medium">Note:</span> If you delete
                          Profile,you will have to re-register by paying
                          Registration fees again in future
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- onccheck 3 Radion Btn  -->
                  <div
                    v-if="type == 'OTHER_REASON'"
                    class="border rounded pt-3"
                  >
                    <h4 class="text-center font-medium mb-4">Other Reason</h4>
                    <div class="row justify-content-center">
                      <div class="col-md-8">
                        <div class="row justify-content-center">
                          <Form ref="OtherReason" @submit="saveSuccessStory()">
                            <div class="col-md-12">
                              <div class="form-group">
                                <label
                                  >Comment/Feedback/Suggestion (If any)</label
                                >

                                <Field
                                  as="textarea"
                                  class="form-control h-auto"
                                  id=""
                                  cols="30"
                                  rows="4"
                                  name="comment"
                                  rules="required:comment"
                                  :validateOnInput="true"
                                  v-model="detail.comment"
                                ></Field>
                                <ErrorMessage
                                  name="comment"
                                  class="text-danger"
                                />
                              </div>
                            </div>
                            <div class="col-12 text-center mt-4">
                              <button
                                id="confirm-delete-button"
                                class="btn btn-brand-1 px-5"
                              >
                                Confirm Delete
                              </button>
                            </div>
                          </Form>
                        </div>
                        <p class="text-center mt-4">
                          <span class="font-medium">Note:</span> If you delete
                          Profile,you will have to re-register by paying
                          Registration fees again in future
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import Multiselect from "@vueform/multiselect";
import coverImagePicker from "@/components/CoverImagePicker.vue";
//import router from "../../router";
export default {
  name: "MySettings",
  components: {
    Form,
    Field,
    ErrorMessage,
    coverImagePicker,
    Multiselect,
  },
  data() {
    return {
      reset: {},
      oldPasswordFieldType: "password",
      newPasswordFieldType: "password",
      PasswordFieldType: "password",
      type: "",
      image: "/images/show-psw.svg",
      imageNew: "/images/show-psw.svg",
      imageOld: "/images/show-psw.svg",
      uuid: this.$route.params.uuid,
      offset: 0,
      list: [],
      registration_no: "",
      file: undefined,
      detail: {
        comment: "",
        type: "",
        registration_no: "",
      },
      bride: {
        registration_no: "",
      },
      groom: {
        native_place_district: {
          name: "",
        },
        registration_no: "",
        groom_user_id: "",
      },
      phoneNumberList: [],
      currentTab: "CONTACT",
      search_data: "",
    };
  },
  mounted() {
    this.changeTab(this.currentTab);
  },

  methods: {
    updatePhoneStatus(data) {
      var count = 0;
      for (var i in this.phoneNumberList) {
        if (this.phoneNumberList[i].is_hidden == "Y") {
          count++;
        }
      }
      if (count == 3) {
        this.$notify({
          type: "error",
          text: "Atleast one contact should be active",
        });
        return (data.is_hidden = "N");
      }
      var obj = {};
      obj.uuid = data.uuid;
      obj.is_hidden = data.is_hidden;
      this.$api
        .putAPI({
          _action: "/update-contact-visibility",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.status,
          });
        })
        .catch(() => {});
    },
    changeTab(tab) {
      this.currentTab = tab;
      if (tab == "CONTACT") {
        this.getPhoneNumberList();
      }
    },
    show(type) {
      this.type = type;
    },
    setDetail(registration_no) {
      var type = this.detail.type;
      this.detail = registration_no;
      this.detail.type = type;
    },

    searchByRefferenceId(e, type) {
      if (e) {
        this.search_data = e;
        if (type) {
          this.detail.type = type;
        }
        this.getList();
      }
    },

    getList() {
      var obj = {};
      if (this.search_data) {
        obj.registration_no = this.search_data;
      }
      if (localStorage.getItem("gender")) {
        obj.gender = localStorage.getItem("gender") == "M" ? "F" : "M";
      }
      this.$api
        .getAPI({
          _action: "/search-by-id",
          _body: obj,
        })
        .then((res) => {
          this.list = res.list;

          for (var j in this.list) {
            if (this.list[j].first_name) {
              this.list[j].name = this.list[j].first_name;
            }
            if (this.list[j].last_name) {
              this.list[j].name += " " + this.list[j].last_name;
            }
            if (this.list[j].registration_no) {
              this.list[j].name += " | " + this.list[j].registration_no;
            }
          }
        })
        .catch(() => {});
    },
    getPhoneNumberList() {
      this.$api
        .getAPI({
          _action: "/get-contact/details",
        })
        .then((res) => {
          this.phoneNumberList = res;
        })
        .catch(() => {});
    },
    saveSuccessStory() {
      var obj = {};
      if (this.type) {
        obj.type = this.type;
      }
      if (this.detail.registration_no) {
        obj.registration_no = this.detail.registration_no;
      }
      if (this.detail.comment) {
        obj.comment = this.detail.comment;
      }
      this.$api
        .postAPI({
          _action: "/user-success-story",
          _body: obj,
          _buttonId: "confirm-delete-button",
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          if (
            this.$refs.ImagePicker?.file &&
            this.type == "THROUGH_NIMBALKAR"
          ) {
            this.uploadImage(res.uuid);
            return;
          }
          localStorage.clear();
          this.$router.push("/home");
        })
        .catch(() => {});
    },
    uploadImage(uuid) {
      if (!this.$refs.ImagePicker?.file) {
        this.$router.go(-1);
        return;
      }
      this.$api
        .uploadImageAPI({
          _action: "/success-story/upload-image",
          _key: "image",
          _file: this.$refs.ImagePicker?.file,
          _body: {
            uuid: uuid,
          },
          _buttonId: "confirm-delete-button",
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.$refs.ImagePicker.file = undefined;
          localStorage.clear();
          this.$router.push("/home");
        });
    },
    selectedFile(e) {
      let files = e.target.files;
      if (
        files[0].type.toLowerCase() != "image/jpeg" &&
        files[0].type.toLowerCase() != "image/png"
      ) {
        alert("Invalid file format please use jpeg or png file.");
        return;
      }
      const size = (files[0].size / 1024 / 1024).toFixed(2);
      if (size > 10) {
        alert("File must be less then 10 MB");
        return;
      }
      var tmppath = URL.createObjectURL(files[0]);
      this.file = files[0];
      document.getElementById("preview").src = tmppath;
    },
    switchVisibilityOld() {
      this.oldPasswordFieldType =
        this.oldPasswordFieldType === "password" ? "text" : "password";
      this.imageOld =
        this.imageOld === "/images/show-psw.svg"
          ? "/images/hide-psw.svg"
          : "/images/show-psw.svg";
    },
    switchVisibilityNew() {
      this.newPasswordFieldType =
        this.newPasswordFieldType === "password" ? "text" : "password";
      this.imageNew =
        this.imageNew === "/images/show-psw.svg"
          ? "/images/hide-psw.svg"
          : "/images/show-psw.svg";
    },
    switchVisibility() {
      this.PasswordFieldType =
        this.PasswordFieldType === "password" ? "text" : "password";
      this.image =
        this.image === "/images/show-psw.svg"
          ? "/images/hide-psw.svg"
          : "/images/show-psw.svg";
    },
    change() {
      this.$api
        .putAPI({
          _action: "/change-password",
          _body: this.reset,
          _buttonId: "save-button",
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          localStorage.clear();
          this.$router.push("/home");
          // this.reset = {};
          // this.$router.push("/home");
        })
        .catch(() => {
          //   this.loader = false;
        });
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.multiselect {
  background: #fff;
  border-radius: 8px;
  border: 1px solid !important;
}

.multiselect-tag {
  background: #d35bc1 !important;
}

.multiselect-search {
  background: none !important;
}
</style>
